export const HOME_FAQS = [
    {
        q: "Do you build shop houses or barndominiums?",
        a: "Yes. Harris Homes designs and builds shop houses and barndominiums — workshop space and finished living space under one roof — on your land in Tahlequah and across Cherokee County.",
    },
    {
        q: "What services does Harris Homes provide?",
        a: "Harris Homes provides custom home building, shop houses and barndominiums, home additions, remodels, renovations, residential construction, project management, and detailed carpentry and finish work in Tahlequah, Oklahoma.",
    },
    {
        q: "Where does Harris Homes build custom homes?",
        a: "Harris Homes is based in Tahlequah, Oklahoma, and serves homeowners in Tahlequah and surrounding areas throughout Northeast Oklahoma.",
    },
    {
        q: "How long does it take to build a custom home?",
        a: "The timeline for a custom home depends on the design, size, materials, and project requirements. Harris Homes works closely with each client to create realistic schedules and maintain clear communication throughout the process.",
    },
    {
        q: "Does Harris Homes handle home remodeling projects?",
        a: "Yes. Harris Homes specializes in kitchen remodels, bathroom renovations, and whole-home updates while preserving the character and improving the functionality of existing spaces.",
    },
    {
        q: "Can Harris Homes build an addition to my existing home?",
        a: "Yes. Harris Homes designs and builds seamless home additions, including extra bedrooms, master suites, expanded living spaces, and second-story additions that blend with your existing home.",
    },
];

export const ABOUT_FAQS = [
    {
        q: "Who is Harris Homes LLC?",
        a: "Harris Homes LLC is a family-run custom home builder based in Tahlequah, Oklahoma. The company specializes in building custom homes, remodeling existing properties, and creating home additions with a focus on craftsmanship, honest communication, and personal service.",
    },
    {
        q: "Where is Harris Homes located?",
        a: "Harris Homes is located in Tahlequah, Oklahoma, and serves homeowners throughout Northeast Oklahoma with custom home construction, renovations, and residential building services.",
    },
    {
        q: "What makes Harris Homes different from other builders in Tahlequah, OK?",
        a: "Harris Homes provides a personalized building experience with direct involvement from the builder. Each project receives careful attention, transparent communication, honest budgeting, and high-quality craftsmanship from start to finish.",
    },
    {
        q: "What types of homes does Harris Homes build?",
        a: "Harris Homes builds fully customized residential homes designed around each family's lifestyle, land, preferences, and long-term needs. Every home is planned and built with attention to quality, functionality, and lasting value.",
    },
    {
        q: "Does Harris Homes offer remodeling services?",
        a: "Yes. Harris Homes provides home remodeling and renovation services, including kitchen remodels, bathroom updates, and whole-home improvements designed to enhance comfort, style, and functionality.",
    },
];

export const SERVICES_FAQS = [
    {
        q: "What services does Harris Homes LLC offer?",
        a: "Harris Homes LLC provides custom home building, home remodeling, additions, residential construction, project management, and detailed carpentry and finish services in Tahlequah, Oklahoma.",
    },
    {
        q: "What does Harris Homes include in custom home building?",
        a: "Harris Homes creates fully customized homes from the initial planning stage to the final walkthrough. Each home is designed around the homeowner's lifestyle, property, preferences, and long-term needs with quality materials and craftsmanship.",
    },
    {
        q: "Does Harris Homes build custom homes in Tahlequah, Oklahoma?",
        a: "Yes. Harris Homes is a custom home builder in Tahlequah, Oklahoma, specializing in personalized residential construction projects with direct builder involvement and attention to detail.",
    },
    {
        q: "Does Harris Homes provide home remodeling services?",
        a: "Yes. Harris Homes offers remodeling and renovation services, including kitchen remodels, bathroom improvements, and whole-home updates that improve functionality while preserving the character of the existing home.",
    },
    {
        q: "What types of home additions does Harris Homes build?",
        a: "Harris Homes designs and builds custom home additions, including new bedrooms, master suites, expanded living areas, and second-story additions that integrate naturally with the existing structure.",
    },
];
